const API_URL = "https://customerapi.ereceipt.in/api/"; // Replace with your actual endpoint
//const API_URL = "http://localhost:5003/api/";
export { API_URL };
